import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function PaymentResult() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center" data-testid="payment-result-page">
      <div className="max-w-sm">
        <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
        <p className="text-lg font-semibold">İşleminiz alındı</p>
        <p className="text-sm text-muted-foreground mt-2">
          Ödeme sonucu doğrulanıyor. Bu pencere birkaç saniye içinde otomatik kapanacaktır.
        </p>
      </div>
    </div>
  );
}
